import { useEffect } from 'react'
import { Typography, Box } from '@mui/material'
import AuthLayout from '../../layouts/authLayout'
import { useNavigate } from 'react-router-dom'
import { store } from 'reduxStore'
import actionTypes from 'store/actions'
import { styled } from '@mui/material/styles'
import { clearFullSearch } from 'store/actions/businessListingActions'
import { useDispatch } from 'react-redux'
import Button from 'components/Common/Button'

const Root = styled(Box)(({theme}) => ({
  maxWidth: theme.spacing(60),
  color: 'var(--primary)',
}))

export const SignOut = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    store.dispatch({ type: actionTypes.RESET_APP_STATE })
    store.dispatch({ type: actionTypes.RESET_SALES_STATE })
    store.dispatch({ type: actionTypes.RESET_USER_STATE })
    store.dispatch({ type: actionTypes.RESET_VAULT_STATE })
    clearFullSearch(dispatch)
    // localStorage.removeItem('GOOGLE_BZ_ID')
  }, [dispatch])

  return (
    <AuthLayout bgType="signIn" noAuthHeader={true}>
      <Root>
        <Typography variant="h5">You have successfully signed out</Typography>
        <Button
          fullWidth
          sx={{marginTop: '10px'}}
          onClick={() => navigate('/auth')}
        >
          Sign back in
        </Button>
      </Root>
    </AuthLayout>
  )
}
